export default function normalize(value?: number, fractionDigits = 2): number {
  if (!value) return 0;
  return Number(value.toFixed(fractionDigits));
}
